**Conditional VaR** (CVaR), also known as Expected Shortfall (ES), is another
representation of risk by size of potential large loss. Instead of estimating
the threshold of an unlikely large loss, CVaR estimates the average loss given
the loss exceeds the threshold. For a confidence level C and the corresponding
VaR, CVaR is the expected value of portfolio loss on the condition that the loss
is larger than VaR.
